export default class ClassificationUnit {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async createClassificationUnit(cuID, description) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/classificationUnit/' + cuID;
    req.body = { description };
    return await req.exec();
  }
  async updateClassificationUnit(cuID, description) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/classificationUnit/' + cuID;
    req.body = { description };
    return await req.exec();
  }
  async deleteClassificationUnit(classificationUnitID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/classificationUnit/' + classificationUnitID;
    return await req.exec();
  }
  async getClassificationUnit(classificationUnitID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/classificationUnit/' + classificationUnitID;
    return await req.exec();
  }
  /* List */
  async getAllClassificationUnits() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/classificationUnits';
    return await req.exec();
  }
}
